<section class="details-container" [ngClass]="{ mobile: rwdService.isSmallDevice, 'no-header': noHeader }">
  <div class="section-header">
    <span class="mat-caption" *ngIf="headerKey"> {{ headerKey | locLabel | uppercase }} </span>
    <ng-content select="[section-header]"></ng-content>
  </div>
  <div class="section-data">
    <ng-content></ng-content>
  </div>
</section>
<mat-divider *ngIf="!last" class="divider"></mat-divider>
